/**
 * Component   : UserManagement
 * Description : Adding / Updating a User
 */

import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Grid,
    Typography,
    Paper
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
    callAPI,
    customValidation,
    EPhone,
    formatPhoneNumber,
    Method,
    updateMainHeader,
    validations,
} from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSSelectField from "../../Components/Select/WSSelect";
import WSPhone from "../../Components/Phone/WSPhone";
import clientConfig from "../../Config/clientConfig.json";
import backImg from "../../images/login-bg.svg";
import backgroundImage1 from "../../images/bg2.svg";
import logo from "../../images/melplogo1.svg";
import doctorImage from "../../images/melp-doctor-login-logo.svg";

export const ForgotPassword: React.FC<any> = React.memo(() => {
    const { showMessage } = useSnackbar();
    const { register, handleSubmit, control, setValue, watch, reset } = useForm();
    const navigate = useNavigate();
    const params = useParams();
    const id = params?.id;
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const phoneNumber = location.state?.phoneNumber;
    useEffect(
        () => () => {
            reset();
        },
        []
    );
    const handleCancelClick = () => {
        navigate("/login");
    };

    const onSubmit = async (data: any) => {
        try {
            setLoading(true);
            const request = {
                phoneNumber: phoneNumber,
                newPassword: data?.password,
            };
            const response: any = await callAPI("/Auth/forgot-password", Method.POST, request);

            if (response) {
                showMessage(
                    response?.message,
                    response.isSuccess ? "success" : "error"
                );
                if (response.isSuccess) navigate("/login");
            }
        } catch (e: any) {
            showMessage(e.error || "Error saving user", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid item container>
            <Grid
                container
                sx={{
                    position: 'relative',
                    //  backgroundImage: `url(${backImg})`,
                    backgroundSize: 'cover',
                    backgroundColor: '#022219',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    minHeight: '100vh',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 2,
                }}
            >  <Box
                    component="img"
                    src={logo}
                    alt="MELP Logo"
                    sx={{
                        position: 'absolute',
                        top: 24,
                        left: 54,
                        width: 100,
                        zIndex: 10,
                    }}
                />
                <Grid container sx={{
                    position: 'relative',
                    minHeight: '80vh',
                    backgroundImage: `url(${backgroundImage1})`,
                    border: '1px solid #022219',
                    borderRadius: 5,
                    backgroundSize: 'cover',
                    backgroundColor: '#022219',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '80%',
                    padding: 7,
                }}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box
                            sx={{
                                backgroundColor: "white",
                                padding: "30px",
                                borderRadius: "12px",
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                maxWidth: "600px",
                                width: "100%",
                                textAlign: "center",
                            }}
                        >
                            <img src={doctorImage} height={100} alt="doctor" />
                            <Typography
                                variant="h5"
                                fontWeight="bold"
                                sx={{ color: "#098963" }}
                            >
                                {"Register"}
                            </Typography>
                            <Typography variant="body2" color="#098963" sx={{ mb: 2 }}>
                                {id
                                    ? "Modify user details below"
                                    : "Fill in the details to create a new user"}
                            </Typography>

                            <Grid container spacing={3} sx={{ textAlign: "left" }}>

                                <Grid item xs={12} sm={6}>
                                    <WSTextField
                                        control={control}
                                        id="password"
                                        {...register("password", {
                                            required: true,
                                            validate: (value: any) =>
                                                value === watch("confirmPassword") ||
                                                "Passwords do not match",
                                        })}
                                        name="password"
                                        label="Password *"
                                        type={TextType.Password}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <WSTextField
                                        control={control}
                                        id="confirmPassword"
                                        {...register("confirmPassword", {
                                            required: true,
                                            validate: (value: any) =>
                                                value === watch("password") ||
                                                "Passwords do not match",
                                        })}
                                        label="Confirm Password *"
                                        type={TextType.Password}
                                    />
                                </Grid>


                                <Grid item xs={12} display="flex" justifyContent="flex-end">
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            mr: 2,
                                            borderColor: "#098963",
                                            color: "#098963",
                                            borderRadius: 2,
                                            px: 4,
                                        }}
                                        onClick={handleCancelClick}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        sx={{
                                            backgroundColor: "#098963",
                                            borderRadius: 2,
                                            px: 4,
                                            "&:hover": {
                                                backgroundColor: "#066e4f",
                                            },
                                        }}
                                        disabled={loading}
                                    >
                                        {loading ? "Saving..." : "Save"}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Grid>
            </Grid>
        </Grid>
    );
});
